import {Component, computed, input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {InvoiceStateId} from '../../../api';

@Component({
  selector: 'elcia-billing-badge',
  imports: [TranslatePipe],
  templateUrl: './billing-badge.html',
  styleUrl: './billing-badge.scss',
  host: {class: 'inline-flex'},
})
export class BillingBadge {
  state = input.required<InvoiceStateId>();

  protected readonly badgeClass = computed(() => {
    switch (this.state()) {
      case InvoiceStateId.SENT:
        return 'bg-green-100 text-green-700';
      case InvoiceStateId.PAID:
        return 'bg-blue-100 text-blue-700';
      case InvoiceStateId.CREDITED:
        return 'bg-orange-100 text-orange-700';
      default:
        return 'bg-[var(--p-surface-200)] text-surface-600';
    }
  });
}
